import { useToken } from '@ori/auth';
import { useGetCustomerSponsorPersonalBeautyStore } from '@ori/global-api-client-react';
var useSponsorPersonalBeautyStoreInfo = function useSponsorPersonalBeautyStoreInfo() {
  var _useToken = useToken(),
    isAnonymousUser = _useToken.isAnonymousUser,
    customerId = _useToken.customerId;
  var result = useGetCustomerSponsorPersonalBeautyStore(customerId, undefined, {
    swr: {
      enabled: !isAnonymousUser
    }
  });
  if (result.error) {
    console.error(result.error);
  }
  return result;
};
export default useSponsorPersonalBeautyStoreInfo;